export default __webpack_public_path__ + "static/media/onlineshop.43e803cd.jpg";